import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { useDispatch, useSelector } from 'react-redux';
import { EmptyState } from './emptyState';
import { LoadingState } from '../../../../_common/loadingState';
import { InvoiceList } from './invoiceList';
import { fetchInvoices, getSetupIntent } from '../../../../actions/user-api';
import * as Loadings from '../../../../constants/loadings/user';
import * as R from 'ramda';

export const SettingsFacturation = () => {
	const dispatch = useDispatch();
	const user = useSelector(state => state.user);
	const [allPayments, setAllPayments] = useState(undefined);

	useEffect(() => {
		dispatch(fetchInvoices());
		$('[data-toggle="tooltip"]').tooltip('update');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (R.isNil(user.stripeClientSecret) && !user.isLoading.includes(Loadings.GETTING_SETUPINTENT)) {
			dispatch(getSetupIntent(user.user));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.stripeClientSecret]);

	useEffect(() => {
		if (!R.isNil(allPayments) && allPayments < user.user.paymentMethods.length) {
			dispatch(getSetupIntent(user.user));
		}
		setAllPayments(user.user.paymentMethods.length);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [!R.isNil(user.user) && user.user.paymentMethods.length]);

	return (
		<div className="auto-view h-100 mb-auto pt-3">
			<div className="container-fluid h-xl-inherit">
				{user.isLoading.includes(Loadings.FETCH_INVOICES) ? <section className="col flex-column justify-content-center py-sm-5 h-xl-inherit text-center"><LoadingState /></section> :
					user.invoices.length === 0 ?
						<EmptyState />
						:
						<InvoiceList />
				}
			</div>
		</div>
	)
};